import * as React from 'react';
import ChartRender from './ChartRender';
import { radarRender } from './chartRender/radarRender';

export default class RadarChart extends React.Component {
    static indentify = 'radar_chart';
    render() {
        return (
            <div className="full-height full-width">
                <ChartRender chartRender={radarRender} {...this.props} />
            </div>
        );
    }
}
